<template>
  <v-menu
    v-model="calendarOpen"
    :close-on-content-click="false"
    min-width="280"
    content-class="dateTimePicker dateRangePicker"
    :top="true"
    :nudge-top="nudgeTop"
    :nudge-right="nudgeRight"
  >
    <template v-slot:activator="{ on, attrs }">
      <div
        v-ripple
        class="dateTimePicker_dateTime"
        v-bind="attrs"
        v-on="!disabled ? on : null"
      >
        <div v-show="!hideData" class="dateTimePicker_select">
          {{ date | dateMs('YYYY/M/D', 'unix') }}
        </div>
        <div class="dateTimePicker_time">
          {{ date | dateMs('HH:mm:ss', 'unix') }}
        </div>
      </div>
    </template>
    <date-picker
      :key="calendarKey"
      v-model="dateVal"
      locale="ja"
      mode="dateTime"
      :masks="masks"
      :max-date="new Date()"
      :min-date="minDate"
      class="dateTimePicker"
      is24hr
      is-expanded
      :is-disable-past-time="isDisablePastTime"
      :custom-classes="customClasses"
    />
    <v-divider />
    <div class="dateRangePicker_actions">
      <div class="dateRangePicker_action">
        <v-btn
          text
          class="dateRangePicker_btn dateRangePicker_btn-cancel"
          @click="calendarOpen = false"
        >
          キャンセル
        </v-btn>
      </div>
      <div class="dateTimePicker_action">
        <v-btn
          text
          class="dateTimePicker_btn dateTimePicker_btn-ok"
          @click="submit"
        >
          設定
        </v-btn>
      </div>
    </div>
  </v-menu>
</template>

<script>
import dayjs from 'dayjs';
import DatePicker from 'v-calendar/src/components/DatePicker.vue';

export default {
  name: 'DateTimePicker',
  components: { DatePicker },
  props: {
    date: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hideData: {
      type: Boolean,
      default: false,
    },
    nudgeTop: {
      type: Number,
      default: 60,
    },
    nudgeRight: {
      type: Number,
      default: -100,
    },
    minDate: {
      type: Date,
      default: null,
    },
    customClasses: {
      type: String,
      default: '',
    },
    isDisablePastTime: {
      type: Boolean,
      default: false,
    },
  },
  /* computed: {
    dateVal: {
      get () {
        return dayjs.unix(this.date).$d
      },
      set (val) {
        const unix = new Date(val).getTime() / 1000
        this.$emit('getDate', unix)
      }
    }
  }, */
  data() {
    return {
      masks: {
        data: 'YYYY/M/DD hh:mm:ss',
        inputDateTime: 'YYYY/M/DD hh:mm:ss',
        input: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
        dayPopover: 'WWW, MMM D, YYYY',
        inputDate: 'YYYY/M/DD',
        inputValue: 'YYYY/M/DD',
        inputDateTime24hr: ['YYYY-MM-DD HH:mm:ss', 'YYYY/MM/DD HH:mm:ss'],
        navMonths: 'MM',
        title: 'YYYY/M',
        iso: 'YYYY/M/DD',
      },
      dateVal: null,
      calendarOpen: false,
      calendarKey: Date.now(),
    };
  },
  watch: {
    calendarOpen(val) {
      if (val) {
        this.calendarKey = Date.now();
      }
    },
    date() {
      if (!this.calendarOpen) {
        this.dateVal = dayjs(this.date).$d;
      }
    },
  },
  created() {},
  methods: {
    submit() {
      this.calendarOpen = false;
      this.$emit('getDate', dayjs(this.dateVal).valueOf());
    },
  },
};
</script>

<style lang="scss">
.dateTimePicker {
  border-radius: 10px;

  .vc-container.vc-is-expanded {
    border-radius: 10px;
    border: none;
  }
  &_dateTime {
    cursor: pointer;
  }
  &_select {
    line-height: 26px;
    margin-top: 3px;
  }
  .vc-arrows-container + div .vc-time-picker {
    padding: 5px 0;
    &:first-child {
      border-right: none;
      border-top: none;
      border-bottom: none;
      &:after {
        content: none;
      }
    }
  }
  .vc-day-content.is-disabled {
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: center;
    color: #ccc;
  }
  .vc-date {
    display: none !important;
  }
  &_actions {
    display: flex;
    width: 100%;
    height: 50px;
    align-items: center;
    box-shadow: 0 -1px 0 0 rgba(0, 0, 0, 0.06);
  }
  &_action {
    display: flex;
    justify-content: center;
    width: 50%;
  }
  &_btn {
    .v-btn__content {
      font-size: 14px;
      font-weight: bold;
    }
    &-cancel {
      .v-btn__content {
        color: #0075c2;
      }
    }
  }
  &-timeSelect {
    background-color: white;
    min-width: 80px !important;
    &.HomeVideo {
      max-height: 255px !important;
    }
  }
}
</style>
